import React, { useReducer } from 'react'
import SettingsContext from './SettingsContext';
import SettingsReducer from './SettingsReducer';
import { getSettingService, setSettingService } from '../../services/Settings';
import { t } from 'i18next';
import { logout } from '../../services/login';

const SettingsState = ({ children }) => {
    const initialState = {
        showSection: [],
        filterName: '',
        switches: [],
        isFetching: false,
        error: {
            ok: false,
            text: ''
        }
    }

    const [state, dispatch] = useReducer(SettingsReducer, initialState);

    const setFetching = (value) => {
        dispatch({
            type: 'SET_FETCHING',
            payload: value
        });
    }

    const setSection = (section) => {
        dispatch({
            type: 'SET_SHOW_SECTION',
            payload: section
        });
    }

    const setFilterName = (name) => {
        dispatch({
            type: 'SET_FILTER_NAME',
            payload: name
        });
    }

    const getSwitchesValues = async () => {
        try {
            let query = '?';

            setFetching(true);

            dispatch({
                type: 'CLEAN_SWITCHES_STATES',
            });

            if (state.showSection.switches?.length) {

                state.showSection.switches.forEach(opt => {
                    query = query.concat(`keyword=${opt.key}&`);
                });

                //search settings
                const items = await getSettingService(query);

                //add value setting in the switch
                state.showSection.switches.forEach(el => {
                    const mathObject = items.data.response.find(op => op.keyword === el.key);
                    if (mathObject) {
                        el.setting_value = mathObject.setting_value;
                    }
                });

                if (items.ok) {
                    dispatch({
                        type: 'GET_SWITCHES_VALUES',
                        payload: {
                            switches: state.showSection.switches,
                            error: {
                                ok: false,
                                text: ''
                            }
                        }
                    });
                } else {
                    let errorMsg;
                    switch (items.data.error_code) {
                        case 'PARAM_ERROR':
                            errorMsg = t('ERROR_TRY_AGAIN');
                            break;
                        case 'PROFILE_ACCESS_ERROR':
                            errorMsg = t('PERMISSIONS_ERROR');
                            setTimeout(() => {
                                logout();
                            }, 1000);
                            break;
                        case 'AUTH_ERROR':
                            errorMsg = t('TOKEN_ERROR');
                            setTimeout(() => {
                                logout();
                            }, 1000);
                            break;
                        default:
                            errorMsg = t('ERROR_TRY_AGAIN');
                            break;
                    }
                    dispatch({
                        type: 'GET_SWITCHES_VALUES',
                        payload: {
                            switches: [],
                            error: {
                                ok: true,
                                text: errorMsg
                            }
                        }
                    });
                }

            }
        } catch (error) {
            dispatch({
                type: 'GET_SWITCHES_VALUES',
                payload: {
                    switches: [],
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
        }
    }

    const setSetting = async (setting) => {
        try {

            const response = await setSettingService(setting);

            if (response.ok) {
                const { keyword, setting_value } = setting;

                state.switches.forEach(el => {
                    if (el.key === keyword) {
                        el.setting_value = setting_value;
                    }
                });

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        switches: state.switches,
                        error: {
                            ok: false,
                            text: ''
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (response.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: 'CHANGE_SETTING',
                    payload: {
                        error: {
                            ok: true,
                            text: errorMsg
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: 'CHANGE_SETTING',
                payload: {
                    error: {
                        ok: true,
                        text: t('SERVER_ERROR')
                    }
                }
            });
            return {
                ok: false
            }
        }
    }

    return (
        <SettingsContext.Provider
            value={{
                settingsState: state,
                setSection,
                setFilterName,
                getSwitchesValues,
                setSetting
            }}
        >
            {children}
        </SettingsContext.Provider>
    )
}

export default SettingsState